import {request} from './request_loc'
import Cookies from 'js-cookie'
import qs from 'qs'

export function add(data) {
    data.maker_id = Cookies.get("maker_id");
    return request({url:'/inbound/add',method:'post',data:qs.stringify(data)});
}
export function getList(page,parameter) {
    var maker_id = Cookies.get("maker_id");
    return request({url:'/inbound/getList?page='+page+'&maker_id='+maker_id,method:'post',data:qs.stringify(parameter)});
}
export function import_mkp_order_id(mkp_order_id) {
    var maker_id = Cookies.get("maker_id");
    return request({url:'/inbound/import_mkp_order_id',params:{maker_id,mkp_order_id}})
}
export function import_sku(sku) {
    var maker_id = Cookies.get("maker_id");
    return request({url:'/inbound/impor_sku',params:{maker_id,sku}})
}